export type CredentialField = {
  label: string;
  value: string;
};

export const telecomLicenseNumber = "豫B2-20261088";

export const businessLicenseFields: CredentialField[] = [
  { label: "统一社会信用代码", value: "91410105MA3XD0UL6M" },
  { label: "公司名称", value: "郑州云轩网络科技有限公司" },
  { label: "公司类型", value: "有限责任公司（自然人投资或控股）" },
  { label: "法定代表人", value: "李森" },
  { label: "注册资本", value: "贰佰万元整" },
  { label: "成立日期", value: "2016年08月18日" },
  {
    label: "住所",
    value:
      "郑州航空港经济综合实验区华夏大道与慈航路交汇处中原数字视听产业园一期（原中部电商产业园）“青合众创（郑州航空港区青年创业园）”11号楼2楼221室",
  },
  {
    label: "经营范围",
    value:
      "一般项目：软件开发；人工智能应用软件开发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；互联网销售（除销售需要许可的商品）；软件销售；信息系统集成服务；数字技术服务；销售代理；日用品销售；信息技术咨询服务；通讯设备销售；信息咨询服务（不含许可类信息咨询服务）；企业管理咨询；企业形象策划；广告发布；广告设计、代理；广告制作；市场营销策划（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）。许可项目：第二类增值电信业务（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）。",
  },
];

export const telecomLicenseFields: CredentialField[] = [
  { label: "许可证编号", value: telecomLicenseNumber },
  { label: "公司名称", value: "郑州云轩网络科技有限公司" },
  { label: "法定代表人", value: "李森" },
  { label: "发证日期", value: "2026年08月31日" },
  { label: "有效期至", value: "2031年08月31日" },
  { label: "网站域名", value: "yunxuanwl.cn" },
  { label: "网站接入服务提供单位", value: "阿里云计算有限公司" },
  {
    label: "服务器放置地址",
    value: "北京市大兴区庆祥北路3号金隅产业园B1号楼",
  },
];

export const telecomBusinessItems = [
  "信息服务业务（仅限互联网信息服务），不含信息搜索查询服务、信息即时交互服务。",
  "在线数据处理与交易处理业务（仅限经营类电子商务），不含网络借贷信息中介类的互联网金融业务。",
];

export const telecomLicensePages = Array.from(
  { length: 8 },
  (_, index) =>
    `/company-credentials/telecom-license/page-${String(index + 1).padStart(2, "0")}.webp`,
);

export const businessLicenseImage =
  "/company-credentials/business-license.webp";
export const telecomLicensePdf =
  "/company-credentials/value-added-telecom-license.pdf";
